import {TFocusableNodeType} from '../Constants/FocusableNodeType';
import FocusableNode from '../FocusableNode';

const findParentOfType = (focusableNode: FocusableNode, types: TFocusableNodeType[]): FocusableNode | null => {
    let parent: FocusableNode | null = focusableNode;

    while (parent) {
        if (types.indexOf(parent.type) > -1) return parent;

        parent = parent.parent;
    }

    return null;
};

export default findParentOfType;
